import { render, staticRenderFns } from "./cross_board.vue?vue&type=template&id=5c8249e9"
import script from "./cross_board.vue?vue&type=script&lang=js"
export * from "./cross_board.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports